
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireee75"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireee75"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $b2HzO = parcelRequire("b2HzO");
const $e73bf42412feb220$var$HOST = "https://beneficios.malldelpacifico.com.ec/calendariodeadviento/";
const $e73bf42412feb220$var$API_BASE_URL = "https://apicapmanias.umpacto.com";
const $e73bf42412feb220$var$shoppingCenterId = 7;
// Notificación
const $e73bf42412feb220$var$toast = (message)=>{
    Swal.fire({
        text: message,
        confirmButtonColor: "#24705e"
    });
};
// Función para validar el número de cédula
const $e73bf42412feb220$var$isCedulaValid = (cedula)=>{
    let total = 0;
    const longitud = cedula.length;
    const longcheck = longitud - 1;
    if (cedula !== "" && longitud === 10) {
        for(let i = 0; i < longcheck; i++){
            let aux = parseInt(cedula.charAt(i));
            if (i % 2 === 0) {
                aux *= 2;
                if (aux > 9) aux -= 9;
            }
            total += aux;
        }
        total = total % 10 ? 10 - total % 10 : 0;
        return cedula.charAt(longitud - 1) === total.toString();
    }
    return false;
};
// Establece el logo y el fondo
const $e73bf42412feb220$var$setImages = ()=>{
    // Obtener el objeto 'shopping' del localStorage
    const shoppingData = localStorage.getItem("shopping");
    // Validar que el objeto exista
    if (shoppingData) try {
        // Parsear el JSON para obtener un objeto
        const shopping = JSON.parse(shoppingData);
        // Establecer la imagen del logo
        const logoElement = document.getElementById("logo");
        if (logoElement && shopping.logoUrl) logoElement.src = `${$e73bf42412feb220$var$API_BASE_URL}${shopping.logoUrl}`;
        // Establecer la imagen de fondo
        const fondoElement = document.getElementById("fondo");
        if (fondoElement && shopping.fondoUrl) fondoElement.style.backgroundImage = `url('${$e73bf42412feb220$var$API_BASE_URL}${shopping.fondoUrl}')`;
    } catch (error) {
        console.error("Error al parsear los datos de shopping:", error);
    }
    else console.warn("No se encontr\xf3 la informaci\xf3n de 'shopping' en localStorage.");
};
// Validar código de registro de usuario
const $e73bf42412feb220$var$handleValidateCodeSubmit = (event)=>{
    event.preventDefault();
    const code = document.getElementById("code").value;
    // Obtener el valor del parámetro 'email' de la URL
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get("email");
    if (!email) {
        $e73bf42412feb220$var$toast("Url incorrecta: no se encontr\xf3 el par\xe1metro email");
        return;
    }
    // Datos a enviar
    const userData = {
        email: email,
        code: code
    };
    (0, $b2HzO.apiRequest)("/auth/verify", "POST", userData).then((response)=>{
        $e73bf42412feb220$var$toast("Gracias por validar tu cuenta.");
        setTimeout(()=>{
            window.location.href = `${$e73bf42412feb220$var$HOST}iniciar-sesion.html?email=${userData.email}`;
        }, 700);
    }).catch((error)=>{
        $e73bf42412feb220$var$toast("Error al validar la cuenta");
    });
};
// Registro de usuarios
const $e73bf42412feb220$var$handleRegistroSubmit = (event)=>{
    event.preventDefault();
    // Verificar si los checkboxes de términos y política están seleccionados
    const acceptTerms = document.getElementById("accept-terms").checked;
    const acceptPolicy = document.getElementById("accept-policy").checked;
    if (!acceptTerms || !acceptPolicy) {
        $e73bf42412feb220$var$toast("Debes aceptar los T\xe9rminos y condiciones y la Pol\xedtica de Protecci\xf3n de Datos.");
        return;
    }
    // Obtener el tipo de identificación y validar el campo 'cedula' según corresponda
    const tipoIdentificacion = document.getElementById("tipo-identificacion").value;
    const cedula = document.getElementById("cedula").value;
    // Validación adicional para el campo 'cedula' en función del tipo de identificación
    if (tipoIdentificacion === "C\xc9DULA" && cedula.length !== 10 || tipoIdentificacion === "RUC" && cedula.length !== 13) {
        $e73bf42412feb220$var$toast("El n\xfamero de identificaci\xf3n no cumple con la longitud requerida.");
        return;
    }
    // Continuar con la validación del resto de campos
    const nombre = document.getElementById("nombre").value;
    const lastName = document.getElementById("apellido").value;
    const genero = document.getElementById("genero").value;
    const fechaNacimiento = document.getElementById("fecha-nacimiento").value;
    const celular = document.getElementById("celular").value;
    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;
    if (!cedula || !nombre || !genero || !fechaNacimiento || !celular || !email || !lastName || !password) {
        $e73bf42412feb220$var$toast("Por favor, completa todos los campos.");
        return;
    }
    if (tipoIdentificacion === "C\xc9DULA" && !$e73bf42412feb220$var$isCedulaValid(cedula)) {
        Swal.fire({
            icon: "error",
            title: "C\xe9dula inv\xe1lida",
            text: "Por favor, ingrese un n\xfamero de c\xe9dula v\xe1lido."
        });
        return;
    }
    // Datos a enviar al backend
    const userData = {
        "tipoIdentificacion": tipoIdentificacion,
        "cedula": cedula,
        "firstName": nombre,
        "lastName": lastName,
        "gender": genero,
        "birthDate": fechaNacimiento,
        "phone": celular,
        "email": email,
        password: password,
        shoppingId: $e73bf42412feb220$var$shoppingCenterId
    };
    (0, $b2HzO.apiRequest)("/user", "POST", userData).then((user)=>{
        $e73bf42412feb220$var$toast(`Bienvenido ${user.firstName}! revisa tu bandeja de entrada.`);
        setTimeout(()=>{
            window.location.href = `${$e73bf42412feb220$var$HOST}validar_cuenta.html?email=${user.email}`;
        }, 600);
    }).catch((error)=>{
        $e73bf42412feb220$var$toast("Gracias tu registro ya puedes iniciar sesi\xf3n.");
        setTimeout(()=>{
            window.location.href = `${$e73bf42412feb220$var$HOST}iniciar-sesion.html?email=${email}`;
        }, 600);
    });
};
// Login
const $e73bf42412feb220$var$handleLoginSubmit = (event)=>{
    event.preventDefault();
    // Capturar y validar los datos del formulario de login
    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;
    // Datos a enviar
    const userData = {
        email: email,
        password: password,
        shoppingCenterId: $e73bf42412feb220$var$shoppingCenterId
    };
    (0, $b2HzO.apiRequest)("/auth/login", "POST", userData).then((response)=>{
        const user = response.user;
        const access_token = response.access_token;
        // const shopping = response.shopping;
        const userShoppingCenter = response.userShoppingCenter;
        // Guardamos las credenciales de acceso
        localStorage.setItem("access_token", access_token);
        localStorage.setItem("user", JSON.stringify(user));
        // localStorage.setItem('shopping', JSON.stringify(shopping));
        $e73bf42412feb220$var$toast(`Bienvenido, ${user.firstName}`);
        setTimeout(()=>{
            window.location.href = userShoppingCenter?.isRegistered ? `${$e73bf42412feb220$var$HOST}calendario.html` : `${$e73bf42412feb220$var$HOST}subir-factura.html`;
        }, 600);
    }).catch((error)=>{
        $e73bf42412feb220$var$toast("Usuario o contrase\xf1a no son correctos");
    });
};
// recuperar contraseña
const $e73bf42412feb220$var$handleForgotPasswordForm = (event)=>{
    event.preventDefault();
    // Capturar y validar los datos del formulario de login
    const email = document.getElementById("email-forgot-password").value;
    // Datos a enviar
    const userData = {
        email: email,
        shoppingCenterId: $e73bf42412feb220$var$shoppingCenterId
    };
    (0, $b2HzO.apiRequest)("/auth/recover-password", "POST", userData).then((response)=>{
        $e73bf42412feb220$var$toast(response?.message);
        setTimeout(()=>{
            window.location.href = `${$e73bf42412feb220$var$HOST}index.html`;
        }, 600);
    }).catch((error)=>{
        $e73bf42412feb220$var$toast("Error al recuperar la contrase\xf1a.");
    });
};
// Obteiene informacion del juego y centro comercial
const $e73bf42412feb220$var$handleDataFetch = async ()=>{
    try {
        // Obtener los parámetros de la URL
        const urlParams = new URLSearchParams(window.location.search);
        const ccParamId = urlParams.get("cc"); // variable solo para administradores
        const gameId = urlParams.get("g");
        // Validar que los parámetros sean números
        const isGameIdValid = gameId && !isNaN(gameId);
        const isCCIdValid = ccParamId && !isNaN(ccParamId);
        const shoppingData = await (0, $b2HzO.apiRequest)(`/shopping-center/${isCCIdValid ? ccParamId : $e73bf42412feb220$var$shoppingCenterId}`);
        localStorage.setItem("shopping", JSON.stringify(shoppingData));
        if (isGameIdValid) try {
            const gameData = await (0, $b2HzO.apiRequest)(`/games/${gameId}`);
            localStorage.setItem("game", JSON.stringify(gameData));
            console.log("Datos del juego guardados:", gameData);
        } catch (error) {
            console.error("Error al obtener datos del juego");
        }
        $e73bf42412feb220$var$setImages();
    } catch (error) {
        console.error("Error al obtener datos del shopping center");
    }
};
document.addEventListener("DOMContentLoaded", ()=>{
    // Crea los localstorages
    $e73bf42412feb220$var$handleDataFetch();
    // Manejo del formulario de registro
    const registroForm = document.getElementById("registro-form");
    // Obtener el valor del parámetro 'email' de la URL y llenar el input si existe
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get("email");
    const emailLogin = document.getElementById("email");
    const code = urlParams.get("code");
    // Si existe 'code', lo establecemos en el input
    if (code) document.getElementById("code").value = code;
    // formulario de registro
    if (registroForm) registroForm.addEventListener("submit", $e73bf42412feb220$var$handleRegistroSubmit);
    // Manejo del formulario de validacion de cuenta
    const validateForm = document.getElementById("validate-form");
    if (validateForm) validateForm.addEventListener("submit", $e73bf42412feb220$var$handleValidateCodeSubmit);
    // Manejo del formulario de login
    const loginForm = document.getElementById("login-form");
    if (loginForm) loginForm.addEventListener("submit", $e73bf42412feb220$var$handleLoginSubmit);
    // Manejo del formulario de forgot-password-form
    const forgotPasswordForm = document.getElementById("forgot-password-form");
    if (forgotPasswordForm) forgotPasswordForm.addEventListener("submit", $e73bf42412feb220$var$handleForgotPasswordForm);
    if (email && emailLogin) emailLogin.value = email;
});


//# sourceMappingURL=calendario.9d447cf1.js.map
